import {CTABanner, Button, Image, Section, Text} from '@primer/react-brand'
import {getAnalyticsEvent} from '@github-ui/swp-core/lib/utils/analytics'

import {Spacer} from './_shared'
import {useCallback, useEffect, useRef, useState} from 'react'
import useIntersectionObserver from '../../lib/hooks/useIntersectionObserver'
import {COPY} from './Cta.data'

export default function Cta() {
  const [isVisible, setIsVisible] = useState<boolean>(false)
  const mascotsRef = useRef<HTMLDivElement | null>(null)
  const ctaRef = useRef<HTMLDivElement | null>(null)

  // TODO: Replace the first once with the WebGL scene's intersection observer logic once added
  const {isIntersecting} = useIntersectionObserver(mascotsRef, {threshold: 0.4, isOnce: true})
  const {isIntersecting: isCtaInView} = useIntersectionObserver(ctaRef, {threshold: 0.4, isOnce: true})

  // TODO: To be called by WebGL scene once added
  const startCopyAnimation = useCallback(() => {
    setIsVisible(true)
  }, [])

  // TODO: To be removed once WebGL scene is added
  useEffect(() => {
    if (isIntersecting) {
      startCopyAnimation()
    }
    // eslint-disable-next-line react-compiler/react-compiler
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isIntersecting])

  return (
    <Section id="cta">
      <Spacer size="100px" />

      <div ref={mascotsRef} className={`lp-Cta-mascots ${!isVisible ? 'lp-Cta-mascots--hidden' : ''}`}>
        <div className="sr-only">{COPY.visual.alt}</div>
        <div>
          <Image src={COPY.visual.url.glowStart} alt="" loading="lazy" />
        </div>
        <div>
          <Image src={COPY.visual.url.glowEnd} alt="" loading="lazy" />
        </div>
        <div>
          <Image src={COPY.visual.url.ducky} alt="" loading="lazy" />
        </div>
        <div>
          <Image src={COPY.visual.url.mona} alt="" loading="lazy" />
        </div>
        <div>
          <Image src={COPY.visual.url.copilot} alt="" loading="lazy" />
        </div>
      </div>

      <Spacer size="48px" size1012="80px" />

      <CTABanner
        ref={ctaRef}
        className={`lp-Cta sh-CtaWithTrial ${isCtaInView ? 'is-visible' : ''}`}
        align="center"
        hasBackground={false}
        hasShadow={false}
      >
        <CTABanner.Heading as="h2">{COPY.heading}</CTABanner.Heading>

        <CTABanner.Description className="lp-Cta-description">{COPY.description}</CTABanner.Description>

        <CTABanner.ButtonGroup>
          <Button
            as="a"
            href={COPY.cta1.url}
            hasArrow={false}
            {...getAnalyticsEvent({action: 'sign_up', tag: 'button', context: 'CTAs', location: 'bottom_cta_section'})}
          >
            {COPY.cta1.label}
          </Button>
          <Button
            as="a"
            href={COPY.cta2.url}
            hasArrow={false}
            {...getAnalyticsEvent({
              action: 'try_copilot',
              tag: 'button',
              context: 'CTAs',
              location: 'bottom_cta_section',
            })}
          >
            {COPY.cta2.label}
            <Text className="sh-CtaWithTrial-label" size="100">
              {COPY.cta2.subLabel}
            </Text>
          </Button>
        </CTABanner.ButtonGroup>
      </CTABanner>
    </Section>
  )
}

try{ Cta.displayName ||= 'Cta' } catch {}